import { z } from 'zod';

import { conversationDetailSchema, conversationListItemSchema, conversationStatusSchema } from '@/schemas/commons';
import type { ZodUseQuery } from '@/utils/zodReactQuery';

export const conversationsListResponse = z.object({
	items: z.array(conversationListItemSchema),
	pagination: z.object({
		page: z.number().int().positive(),
		pageSize: z.number().int().positive(),
		totalItems: z.number().int().nonnegative(),
		totalPages: z.number().int().nonnegative(),
	}),
	totals: z.object({
		costUsdFiltered: z.number().nonnegative(),
		costUsdPeriod: z.number().nonnegative(),
	}),
});

export type ConversationsListResponse = z.infer<typeof conversationsListResponse>;

export const conversationsParams = z
	.object({
		page: z.number().int().positive().optional(),
		pageSize: z.number().int().positive().optional(),
		moduleName: z.string().optional(),
		channel: z.string().optional(),
		country: z.string().optional(),
		period: z.enum(['today', '7d', '30d']).optional(),
		search: z.string().optional(),
		status: conversationStatusSchema.optional(),
	})
	.partial();

export type ConversationsParams = z.infer<typeof conversationsParams>;

export const conversationDetailResponse = conversationDetailSchema;
export type ConversationDetailResponse = z.infer<typeof conversationDetailResponse>;

export const agentEventSchema = z.object({
	id: z.number().int(),
	occurredAt: z.string(),
	eventType: z.string(),
	summary: z.string().nullish(),
	durationMs: z.number().int().nullish(),
	payload: z.record(z.unknown()).default({}),
});

export type AgentEvent = z.infer<typeof agentEventSchema>;

export const conversationEventsResponse = z.object({
	threadId: z.string(),
	variants: z.record(z.string()),
	events: z.array(agentEventSchema),
});

export type ConversationEventsResponse = z.infer<typeof conversationEventsResponse>;

export type UseConversations = ZodUseQuery<ConversationsListResponse, ConversationsParams>;
export type UseConversation = ZodUseQuery<ConversationDetailResponse, { threadId: string }>;
export type UseConversationEvents = ZodUseQuery<ConversationEventsResponse, { threadId: string }>;
